import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-submit-search"
export default class extends Controller {
  connect() {
  }

  submit(event) {
    if (0 < event.currentTarget.value.length && event.currentTarget.value.length < 3 ){ return }

    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, 250)
  }
}
